var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZeropercent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 79,
    viewBox: "0 0 53 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.5672 64.5439C28.4637 64.7749 28.3805 65.0351 28.2658 65.2438C27.1975 67.1863 25.1239 68.1576 22.0472 68.1576C18.9706 68.1576 16.8002 67.1863 15.7342 65.2438C14.6659 63.3035 14.1329 60.4839 14.1329 56.7849V21.7317C14.1329 18.1001 14.6659 15.3276 15.7342 13.4142C16.8002 11.5031 18.9053 10.5475 22.0472 10.5475C25.1891 10.5475 27.2762 11.4874 28.313 13.3671C29.3498 15.2469 29.8671 18.0351 29.8671 21.7317V30.3924H44V24.9282C44 16.8462 42.3042 10.736 38.9127 6.60189C35.5212 2.46558 29.8986 0.399658 22.0472 0.399658C14.1959 0.399658 8.47884 2.46782 5.0873 6.60189C1.69577 10.736 0 16.8462 0 24.9282V53.4965C0 61.6413 1.69577 67.8278 5.0873 72.0561C8.47884 76.2844 14.1329 78.3997 22.0472 78.3997C29.9616 78.3997 35.4424 76.2709 38.8677 72.009C40.5095 69.9655 41.7487 67.4689 42.6034 64.5439H28.5694H28.5672Z",
    fill: "url(#paint0_linear_1_1982)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.9345 46.5035C20.6448 45.1514 20 43.3048 20 40.9662C20 39.4313 20.2955 38.0927 20.8889 36.9482C21.4822 35.8037 22.3016 34.9256 23.345 34.3161C24.3906 33.7067 25.5817 33.3997 26.9229 33.3997C28.9849 33.3997 30.6619 34.0814 31.9516 35.4471C33.2412 36.8127 33.886 38.6525 33.886 40.9662C33.886 43.28 33.2412 45.1536 31.9516 46.5035C30.6619 47.8556 28.9849 48.5306 26.9229 48.5306C24.8608 48.5306 23.2219 47.8556 21.9322 46.5035H21.9345ZM42.9404 33.7495H48.5109L30.0193 61.0498H24.4488L42.9404 33.7495ZM28.5886 43.8895C29.0006 43.2665 29.2066 42.2913 29.2066 40.964C29.2066 39.6367 29.0006 38.6638 28.5886 38.0385C28.1767 37.4155 27.6214 37.1017 26.9251 37.1017C26.2288 37.1017 25.7071 37.42 25.2817 38.0588C24.8563 38.6954 24.6436 39.6638 24.6436 40.964C24.6436 42.2642 24.8563 43.2326 25.2817 43.8692C25.7071 44.5057 26.2556 44.824 26.9251 44.824C27.5945 44.824 28.1767 44.5125 28.5886 43.8872V43.8895ZM41.026 59.3726C39.7498 58.0204 39.1117 56.1739 39.1117 53.8331C39.1117 51.4922 39.7566 49.6796 41.0462 48.3139C42.3358 46.9482 43.9994 46.2665 46.0368 46.2665C48.0743 46.2665 49.7759 46.9482 51.0655 48.3139C52.3552 49.6796 53 51.5193 53 53.8331C53 56.1468 52.3552 58.0204 51.0655 59.3726C49.7759 60.7247 48.0989 61.3997 46.0368 61.3997C43.9748 61.3997 42.3045 60.7247 41.0283 59.3726H41.026ZM47.6981 56.7608C48.1101 56.1378 48.3161 55.1626 48.3161 53.8353C48.3161 52.508 48.1101 51.5351 47.6981 50.9098C47.2862 50.2868 46.7309 49.973 46.0346 49.973C45.3383 49.973 44.783 50.2845 44.371 50.9098C43.9591 51.5328 43.7531 52.508 43.7531 53.8353C43.7531 55.1626 43.9591 56.1355 44.371 56.7608C44.783 57.3838 45.3383 57.6954 46.0346 57.6954C46.7309 57.6954 47.2862 57.3838 47.6981 56.7608Z",
    fill: "url(#paint1_linear_1_1982)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1982",
    x1: 21.9193,
    y1: -12.1986,
    x2: 22.0683,
    y2: 78.3995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1982",
    x1: 36.4394,
    y1: 28.8772,
    x2: 36.465,
    y2: 61.3997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7351",
    stopOpacity: 0.76
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#583095",
    stopOpacity: 0.79
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeropercent);
export default __webpack_public_path__ + "static/media/zeropercent.7e8e58347464f7aa4b81118042f19c31.svg";
export { ForwardRef as ReactComponent };